module.exports = __webpack_public_path__ + "static/media/me.5b2c4df2.jpg";